import { motion } from "motion/react";

export function StepWrapper({ children }: { children: React.ReactNode }) {
  return (
    <motion.div
      initial={{ opacity: 0, x: 24 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -24 }}
      transition={{ duration: 0.25, ease: "easeOut" }}
    >
      {children}
    </motion.div>
  );
}

export function StepHeading({
  step,
  title,
  sub,
}: {
  step?: string;
  title: string;
  sub: string;
}) {
  return (
    <div className="mb-6">
      {step && (
        <p
          className="text-[12px] text-violet-600 uppercase tracking-widest mb-2"
          style={{ fontWeight: 700 }}
        >
          {step}
        </p>
      )}
      <h2
        className="text-[24px] text-slate-900 tracking-tight mb-2"
        style={{ fontWeight: 800 }}
      >
        {title}
      </h2>
      <p
        className="text-[14px] text-slate-500 leading-relaxed"
        style={{ fontWeight: 400 }}
      >
        {sub}
      </p>
    </div>
  );
}
